<template>
  <a-row>
    <!--左侧档案合成器-->
    <a-card :bordered="false" style="width: 250px; float: left">
      <div>
        <h3>
          档案合成器
          <a-tooltip>
            <template #title>
              <div>一键完成档案合成</div>
              <div>1、3分钟时完成心理筛查</div>
              <div>2、支持导入各种心理量表，一键合成新档案</div>
              <div>3、情绪指数多维度分析，学生心理筛查更精准</div>
              <div>4、支持多种形式筛选排序</div>
              <div>5、档案记录永久保存</div>
            </template>
            <a-icon type="info-circle" style="cursor: pointer; color: dodgerblue" />
          </a-tooltip>
        </h3>

        <h5>
          <span style="color: red">*</span>
          仅支持xlsx和xls格式的文件
        </h5>
      </div>
      <a-button
        @click="showModal"
        style="
          background: rgb(250, 150, 0);
          color: white;
          font-weight: bold;
          width: 100%;
          height: 35px;
          solid-color: #faad14;
        "
      >
        导入文件
      </a-button>

      <!-- 合成历史 -->
      <a-row :gutter="[24, 12]" style="margin-top: 20px">
        <template v-for="item in archiveList">
          <a-col
            span="16"
            style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; cursor: pointer"
            @click="showArchiveData(item)"
          >
            <a-icon type="file-excel" style="color: #52c41a" />
            {{ item.title }}
          </a-col>
          <a-col span="8">
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDeleteArchive(item.id)">
              <a>删除</a>
            </a-popconfirm>
          </a-col>
        </template>
      </a-row>

      <!-- 弹窗 -->
      <a-modal title="档案合成器" v-model="isModalVisible" :width="widthDialog">
        <template #footer>
          <a-button @click="handleCancel">取消</a-button>
          <a-button
            :disabled="fileList.length === 0"
            :loading="uploading"
            type="primary"
            @click="handleOk"
          >
            一键合成
          </a-button>
        </template>
        <div>
          <a-form-model ref="form" :model="model" :rules="validatorRules">
            <a-form-model-item label="第一步：下载模版">
              <a
                :href="window._CONFIG['resourceURL'] + '/school/sys/common/static/ArchiveSynthesizer/学生心理档案合成器模版.xlsx'"
              >
                下载导入心理档案Excel模版
              </a>
            </a-form-model-item>
            <a-form-model-item label="第二步：输入生成文档标题" prop="title">
              <a-input
                style="width: 100%"
                placeholder="请输入文档标题"
                v-model="model.title"
              ></a-input>
            </a-form-model-item>

            <a-form-model-item label="第三步：添加文件">
              <a-upload-dragger
                accept=".xls,.xlsx"
                name="file"
                :file-list="fileList"
                :multiple="true"
                :action="uploadAction"
                :headers="tokenHeader"
                @change="handleChange"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">添加文件</p>
                <p class="ant-upload-hint">(仅支持.xls或.xlsx格式的文件)</p>
              </a-upload-dragger>
            </a-form-model-item>
          </a-form-model>
        </div>
      </a-modal>
    </a-card>

    <!--右侧数据列表-->
    <a-card :bordered="false" style="margin-left: 20px; width: calc(100% - 274px); float: left">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="年级名称">
                <j-dict-select-tag
                  :disabled="isShowArchiveData"
                  placeholder="请选择年级"
                  v-model="queryParam.gradeId"
                  dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                  style="width: 250px"
                  allowClear
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="班级名称">
                <j-dict-select-tag
                  :disabled="isShowArchiveData"
                  placeholder="请选择班级"
                  v-model="queryParam.classId"
                  :dictCode="
                    'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                  "
                  :async="true"
                  style="width: 250px"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="学生姓名">
                <a-input
                  :disabled="isShowArchiveData"
                  placeholder="请输入学生姓名"
                  v-model="queryParam.name"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="是否关爱名单">
                <j-dict-select-tag
                  :disabled="isShowArchiveData"
                  v-model="queryParam.careList"
                  placeholder="请选择是否关爱名单"
                  dictCode="yn"
                />
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="时间范围">
                <a-select
                  :disabled="isShowArchiveData"
                  placeholder="请选择时间范围"
                  v-model="queryParam.timeRange"
                  style="width: 250px"
                  @change="onTimeRangeChange"
                >
                  <a-select-option value="xz">请选择</a-select-option>
                  <a-select-option value="last7days">近七日</a-select-option>
                  <a-select-option value="last20days">近二十天</a-select-option>
                  <a-select-option value="last40days">近四十天</a-select-option>
                  <a-select-option value="last3months">近三个月</a-select-option>
                  <a-select-option value="last6months">近半年</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="6">
              <a-form-item label="时间范围">
                <a-range-picker
                  :disabled="isShowArchiveData"
                  :value="rangeDate"
                  @change="onRangeChange"
                  style="width: 250px"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                <a-button
                  type="primary"
                  :disabled="isShowArchiveData"
                  @click="searchQuery"
                  icon="search"
                >
                  查询
                </a-button>
                <a-button type="primary" @click="reset" icon="reload" style="margin-left: 8px">
                  重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button v-show="isShowArchiveData" type="primary" icon="download" @click="exportXls">
          导出
        </a-button>
      </div>

      <!-- table区域-begin -->
      <div>
        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="columns"
          :scroll="{ x: true }"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a @click="changeSelect(record)">更多</a>
          </span>
        </a-table>
      </div>
      <!-- table区域-end -->
    </a-card>

    <ViewKeyPointModal ref="viewKeyPointModal" />
  </a-row>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { deleteAction, getAction, postAction } from '../../../api/manage'
import moment from 'moment'
import * as XLSX from 'xlsx'
import ViewKeyPointModal from './components/ViewKeyPointModal'

export default {
  name: 'ArchiveSynthesizer',
  mixins: [JeecgListMixin],
  components: {
    JSearchSelectTag,
    ViewKeyPointModal,
  },
  mixins: [JeecgListMixin],
  data() {
    return {
      //查询数据范围
      rangeDate: [],
      widthDialog: 700,
      isModalVisible: false, // 控制弹窗显示状态
      uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=ArchiveSynthesizer',
      model: {},
      validatorRules: {
        title: { required: true, message: '文档标题不能为空!' },
      },
      // 表头
      defaultColumns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          sorter: (a, b) => a['className'].localeCompare(b['className']),
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          sorter: (a, b) => a['studentName'].localeCompare(b['studentName']),
          scopedSlots: { customRender: 'studentName' },
        },
        {
          title: '学生(本期)',
          align: 'center',
          sorter: (a, b) => a['personHappyRate'] - b['personHappyRate'],
          dataIndex: 'personHappyRate',
        },
        {
          title: '学生(往期)',
          align: 'center',
          sorter: (a, b) => a['historyHappyRate'] - b['historyHappyRate'],
          dataIndex: 'historyHappyRate',
        },
        {
          title: '班级(本期)',
          align: 'center',
          sorter: (a, b) => a['classHappyRate'] - b['classHappyRate'],
          dataIndex: 'classHappyRate',
        },
        {
          title: '年级(本期)',
          align: 'center',
          sorter: (a, b) => a['gradeHappyRate'] - b['gradeHappyRate'],
          dataIndex: 'gradeHappyRate',
        },
        {
          title: '关爱名单',
          align: 'center',
          dataIndex: 'careList',
          sorter: (a, b) => a['careList'] - b['careList'],
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        // {
        //   title: '家长访问(次)',
        //   align: "center",
        //   sorter: (a, b) => a['visitCnt'] - b['visitCnt'],
        //   dataIndex: 'visitCnt'
        // },
      ],
      columns: [],
      url: {
        list: '/statistic/studentMoodTrend',
        archiveList: '/schoolArchive/list',
        archiveDelete: '/schoolArchive/delete',
        importExcelUrl: '/schoolArchive/importExcel',
        exportXlsUrl: '/schoolArchive/exportXls',
        analysis: '/schoolArchive/analysis',
      },
      fileList: [],
      uploading: false,
      archiveList: [],
      isShowArchiveData: false,
      showArchiveId: '',
      currentStudentName: '',
      currentStudentId: '',
      chartLoading: false,
      modelVisible: false,
    }
  },
  created() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

    //获取列表数据
    this.searchData()

    //获取档案合成历史
    this.searchArchive()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    searchData() {
      this.columns = Object.assign([], this.defaultColumns)
      this.columns.push({
        title: '操作',
        align: 'center',
        fixed: 'right',
        dataIndex: 'action',
        width: 100,
        scopedSlots: { customRender: 'action' },
      })
      this.searchQuery()
    },
    showModal() {
      this.model = {}
      this.fileList = []
      this.isModalVisible = !this.isModalVisible // 显示弹窗
    },
    handleOk() {
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.uploading = true

          this.model.beginDate = this.queryParam.beginDate
          this.model.endDate = this.queryParam.endDate

          this.model.fileList = []
          this.fileList.forEach((item) => {
            this.model.fileList.push(item.response.message)
          })

          postAction(this.url.importExcelUrl, this.model).then((res) => {
            if (res.code === 200) {
              this.$message.success(res.message)
              this.showModal()
              this.searchArchive()
              this.showArchiveData(res.result)
            } else {
              this.$message.warning(res.message)
            }
            this.uploading = false
          })
        }
      })
    },
    handleCancel() {
      this.isModalVisible = false // 取消后关闭弹窗
      this.model = {}
    },
    handleChange(info) {
      let fileList = [...info.fileList]

      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })

      this.fileList = fileList
    },
    onRangeChange(dates, dateString) {
      if (dates && dates.length) {
        // 用户选择了日期范围
        this.rangeDate = dates
        this.queryParam.beginDate = dateString[0]
        this.queryParam.endDate = dateString[1]
      } else {
        // 用户清除了日期选择，默认设置为一周的数据
        this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
        this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
        this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      }
      this.queryParam.timeRange = 'xz'
      this.searchQuery()
    },
    onTimeRangeChange(value) {
      let startDate = null

      switch (value) {
        case 'xz':
          startDate = moment().subtract(14, 'days')
          break
        case 'last7days':
          startDate = moment().subtract(7, 'days')
          break
        case 'last20days':
          startDate = moment().subtract(20, 'days')
          break
        case 'last40days':
          startDate = moment().subtract(40, 'days')
          break
        case 'last3months':
          startDate = moment().subtract(3, 'months')
          break
        case 'last6months':
          startDate = moment().subtract(6, 'months')
          break
        default:
          startDate = null
      }

      // 如果选择的时间范围不为null，则设置beginDate值
      if (startDate) {
        this.rangeDate = [startDate, moment().subtract(1, 'days')]
        this.queryParam.beginDate = startDate.format('YYYY-MM-DD')
      } else {
        this.queryParam.beginDate = null
      }

      // 这里可以加入你的其他逻辑，比如重新发起查询
      this.searchQuery()
    },
    searchArchive() {
      getAction(this.url.archiveList).then((res) => {
        this.archiveList = []
        if (res.code === 200) {
          this.archiveList = res.result.records
        }
      })
    },
    handleDeleteArchive(id) {
      var that = this
      deleteAction(that.url.archiveDelete, { id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.searchArchive()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    /**
     * 展示档案合成数据
     */
    showArchiveData(record) {
      this.showArchiveId = record.id
      this.isShowArchiveData = true
      this.columns = Object.assign([], this.defaultColumns)

      var data = JSON.parse(record.jsonString)
      data.allColumns.forEach((column) => {
        this.columns.push({
          title: column,
          align: 'center',
          sorter: (a, b) => a[column] - b[column],
          dataIndex: column,
        })
      })
      this.columns.push({
        title: '操作',
        align: 'center',
        fixed: 'right',
        dataIndex: 'action',
        width: 100,
        scopedSlots: { customRender: 'action' },
      })

      this.dataSource = data.data.records
      this.ipagination.total = data.data.total
      this.ipagination.pageSize = 500
    },
    /**
     * 重置
     */
    reset() {
      this.showArchiveId = ''
      this.queryParam = {}
      this.isShowArchiveData = false
      this.ipagination.pageSize = 10
      this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
      this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
      this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
      this.searchData()
    },
    /**
     * 导出excel
     */
    exportXls() {
      const exportData = []
      this.dataSource.forEach((data) => {
        var singleData = {}
        this.columns.forEach((column) => {
          if (column.title !== '#' && column.title !== '操作') {
            singleData[column.title] = data[column.dataIndex]
          }
        })
        exportData.push(singleData)
      })

      console.log('导出的数据--', exportData)

      // 将数据转化为xlsx的表格数据结构
      const ws = XLSX.utils.json_to_sheet(exportData)

      // 新建工作簿并添加表格数据
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, '档案合成器')

      // 生成Excel文件并导出
      XLSX.writeFile(wb, '档案合成器.xlsx')
    },
    changeSelect(record) {
      this.$refs.viewKeyPointModal.show({ id: record.studentId, name: record.studentName }, 2)
    },
  },
}

// 将字符串转换为ArrayBuffer
function s2ab(s) {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
  return buf
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
